module.exports = __webpack_public_path__ + "img/1.15f1e727.png";